<template>
	<div class="contains" @click="defaul">
		<header class="head">
			<div class="tabs">
				<router-link
					active-class="on"
					v-for="(item, index) in menus"
					:to="item.path"
					:key="index"
					>{{ item.title }}</router-link
				>
			</div>
			<div class="group">
				<div class="g-header">
					<stateTimer ref="stateTimeChild" />
					<!-- <div class="work cursor" @click.stop="state">
						<i :class="currentState.icons"></i>
						<span>
							{{currentState.status}}
							(
							<span style="color: #0f7df3;font-weight: 500;">
								<chronograph :countVals="currentState.currentTime" isStarts />
							</span>
							)
						</span>
						<i class="iconfont icon-down"></i>
						<ul class="dropdown-menu fadeInDown" v-if="show1">
							<li :key="index" v-for="(item,index) in userStates" @click="selectedStates(item)">
								<i :class="item.icon"></i>
								{{item.name}}
							</li>
						</ul>
					</div>-->
					<div class="manage cursor" @click.stop="quit">
						<el-avatar
							shape="square"
							:size="32"
							style="border-radius: 50%; vertical-align: middle"
							:src="UserInfo.headimg"
						></el-avatar>
						<span>{{ UserInfo.nickName }}</span>
						<i class="iconfont icon-down"></i>
						<ul class="dropdown-menu fadeInDown" v-if="show">
							<li
								v-if="
									UserInfo.roleId != 3 && UserInfo.roleId != 0
								"
								@click="switchBack()"
							>
								切换后台
							</li>
							<li @click.stop="uploadPassword()">
								<a id="password">修改密码</a>
							</li>
							<li @click.stop="quitSignIn()">
								<a id="quit" v-preventReClick>退出</a>
							</li>
						</ul>
					</div>
				</div>

				<!-- <el-date-picker v-model="value1" type="date" placeholder="选择日期" class="date"></el-date-picker>
				<div class="search">
					<el-dropdown class="dropmenu">
						<el-button type>
							更多菜单
							<i class="el-icon-arrow-down el-icon--right"></i>
						</el-button>
						<el-dropdown-menu slot="dropdown"></el-dropdown-menu>
					</el-dropdown>
					<el-input placeholder="请输入内容" v-model="input10" clearable class="search_box">
						<input type="text" autocomplete="off" placeholder="请输入内容" />
					</el-input>
				</div>-->
			</div>
		</header>
		<div class="flex">
			<!-- <div :is="movement"></div> -->
			<router-view
				@updUserHeadimg="updUserHeadimg"
				@conversationCount="conversationCount"
				ref="customerChilder"
			/>
		</div>
	</div>
</template>
<script>
import hhrecord from '@/components/customer/hhrecords/hhrecord'
import talk from '@/components/customer/talks/talk'
import chronograph from './chronograph'
import { DateTime } from '@/utils/common'
import { SignarStart } from '@/utils/utilsSignar'
import stateTimer from './stateTimer'
// import '@/components/customer/customers/index.css'
import preventReClick from '@/utils/preventReClick'
let emojiData = require('@/assets/emoji/emoji.json')
export default {
	name: 'customs',
	props: [],
	data() {
		return {
			menus: [
				{
					title: '当前会话',
					path: '/customs/talks',
				},
				{
					title: '留言记录',
					path: '/customs/lyrecord',
				},
				{
					title: '工作报表',
					path: '/customs/report',
				},
				{
					title: '会话记录',
					path: '/customs/hhrecord',
				},
				{
					title: '设置',
					path: '/customs/setting',
				},
			],
			UserInfo: {
				nickName: '客服1号',
				headimg: '',
				roleId: 0,
			},
			value1: '',
			input5: '',
			select: '',
			input10: '',
			input11: '',
			show: false,
			show1: false,
			show3: false,
			show4: false,
			show5: false,
			currentState: {
				id: 2,
				icons: 'iconfont  icon-qianchu',
				status: '迁出',
				currentTime: 0,
			},
			eindex: 0,
			answer: 'answer',
			reply: 'reply',
			tabclass1: 'on',
			tabclass2: '',
			common_words: [
				{
					title: '常用语 客服不在请稍后咨询',
				},
				{
					title: '常用语2',
				},
				{
					title: '常用语3',
				},
			],
			userStates: [],
			conversationDataCount: 0, //当前的会话数量
		}
	},
	watch: {},

	created: function () {
		//Kf@20200303
	},
	mounted: function () {
		let vm = this
		var account = localStorage.getItem('Terst')
		let user_info = window.localStorage.getItem('USER_INFO')
		let obj = user_info != null ? JSON.parse(user_info) : null
		// if (obj != null) {
		// 	if (
		// 		obj.account != 'Nestle2020001' &&
		// 		obj.account != 'Nestle2020002'
		// 	) {
		// 		var obj1 = new Object()
		// 		obj1.title = '设置'
		// 		obj1.path = '/customs/setting'
		// 		this.menus.push(obj1)
		// 	}
		// }

		vm.currentTime = Date.now()
		// window.addEventListener('beforeunload', e => {
		// 	e.returnValue = '确定要关闭嘛?'
		// 	return e
		// })
		// window.isCloseHint = true
		//初始化关闭
		// window.addEventListener('beforeunload', function(e) {
		// 	if (window.isCloseHint) {
		// 		var confirmationMessage = '要记得保存！你确定要离开我吗？'
		// 		;(e || window.event).returnValue = confirmationMessage // 兼容 Gecko + IE
		// 		return confirmationMessage // 兼容 Gecko + Webkit, Safari, Chrome
		// 	}
		// })
		let json = localStorage.getItem('CURRENTSTATE')
		if (json != undefined) {
			vm.currentState = JSON.parse(json)
		} else {
			vm.currentState.currentTime = Date.now()
			localStorage.setItem(
				'CURRENTSTATE',
				JSON.stringify(vm.currentState)
			)
			// this.axios
			// 	.get('user/UpdCurrentState', {
			// 		params: { stateId: vm.currentState.id }
			// 	})
			// 	.then(function({ data }) {
			// 		if (!data.result) {
			// 			vm.$notify.error({
			// 				title: '错误',
			// 				message: data.message
			// 			})
			// 		}
			// 	})
		}

		this._globle.timing = setInterval(function () {
			vm.axios.get('login/refresh').then(function (data) {
				console.log(data)
			})
		}, 60000)

		console.log('timing' + this._globle.timing)
	},
	beforeunload: function () {
		alert('dsfasdf')
	},
	components: {
		// lyrecord,
		talk,
		chronograph,
		stateTimer,
		// report,
		// hhrecord,
		// setting
	},
	created: function () {
		let loginModel = JSON.parse(localStorage.getItem(this.LoginInfo))
		this.UserInfo.nickName = loginModel.nickName
		this.UserInfo.headimg = loginModel.headimg
		this.UserInfo.roleId = loginModel.roleId
		this.getUserStates()
		let vm = this
		this.connection.on('SignInMsg', (message) => {
			let obj = localStorage.getItem(vm.LoginInfo) //写入缓存
			let obj1 = JSON.parse(obj)
			if (
				message &&
				obj1 &&
				message.conversationId == obj1.conversationId &&
				message.signInTime > obj1.signInTime
			) {
				vm.$confirm('您的账号已在其他地方登录！', '提示', {
					confirmButtonText: '确定',
					type: 'error',
					center: true,
					showCancelButton: false,
					showClose: false,
					closeOnClickModal: false,
					closeOnPressEscape: false,
				}).then(() => {
					// vm.quitSignIn(1)
					vm.squeezeDown()
				})
			}
		})
		SignarStart() //检查是否连接
	},
	destroyed: function () {
		window.removeEventListener('beforeunload', (e) =>
			this.beforeunloadHandler(e)
		)
	},
	methods: {
		beforeunloadHandler(e) {
			// ...
			alert('12321321')
		},
		quitSignIn(str) {
			this.getConversationCount()
			if (this.conversationDataCount > 0) {
				this.$confirm(
					'温馨提醒：当前仍有会话未处理，请全部处理后在退出~',
					'提示',
					{
						confirmButtonText: '确定',
						type: 'warning',
						center: true,
						showCancelButton: false,
					}
				).then(() => {})
				return
			}
			let loginModel = JSON.parse(localStorage.getItem(this.LoginInfo))
			let $this = this
			this.axios
				.get('Login', {
					params: { state: str },
				})
				.then(function ({ data }) {
					if (str == undefined) {
						// $this.updateDuration()
						$this.$message.success('退出成功')
					}
					localStorage.clear()
					$this.$router.push({ path: '/login' })
				})
		},
		getUserStates() {
			let vm = this
			this.axios.get('User/GetUserStates').then(function ({ data }) {
				if (data.result) {
					vm.userStates = data.data
				}
			})
		},
		squeezeDown() {
			let loginModel = JSON.parse(localStorage.getItem(this.LoginInfo))
			let $this = this
			this.axios
				.get('Login/SqueezeDown', {
					params: { token: loginModel.token },
				})
				.then(function ({ data }) {
					if (data.result) {
						localStorage.clear()
						$this.$router.push({ path: '/login' })
					}
				})
		},
		quit(data) {
			if (this.show) {
				this.show = false
			} else {
				this.show = true
				this.show1 = false
			}
		},
		state(data) {
			if (this.show1) {
				this.show1 = false
			} else {
				this.show1 = true
				this.show = false
			}
		},
		defaul(data) {
			this.show = false
			this.show1 = false
			this.show4 = false
		},

		toggle(item) {
			console.log(item)
			item.ishow = !item.ishow
			if (item.icon == 'el-icon-caret-right') {
				item.icon = 'el-icon-caret-bottom'
			} else {
				item.icon = 'el-icon-caret-right'
			}
			console.log(item)
		},
		tab(index) {
			this.eindex = index
		},

		upload() {
			this.$refs.file.click()
			console.log(this.$refs.file)
		},
		close() {
			this.reply = 'reply on'
			this.answer = 'answer on'
		},
		switchto(data) {
			if (data == 0) {
				this.tabclass1 = 'on'
				this.tabclass2 = ''
			} else {
				this.tabclass1 = ''
				this.tabclass2 = 'on'
			}
		},
		getConversationCount() {
			var str = this.$route.path
			if (str != undefined && str.indexOf('/customs/talks') > -1) {
				this.$refs['customerChilder'].asynConversationCount()
			}
		},
		switchBack() {
			this.getConversationCount()
			if (this.conversationDataCount > 0) {
				this.$confirm(
					'温馨提醒：当前仍有会话未处理，请全部处理后再切换管理后台~',
					'提示',
					{
						confirmButtonText: '确定',
						type: 'warning',
						center: true,
						showCancelButton: false,
					}
				).then(() => {})
				return
			}
			this.$refs.stateTimeChild.setUpMoveOut()
			this.$router.push('/manage/staff').catch((err) => {
				console.log(err)
			})
		},
		selectedStates(item) {
			let vm = this
			if (item.name !== vm.currentState.status) {
				let time = Date.now()
				// vm.updateDuration()
				vm.currentState.id = item.id
				vm.currentState.icons = item.icon
				vm.currentState.status = item.name
				vm.currentState.currentTime = time
				localStorage.setItem(
					'CURRENTSTATE',
					JSON.stringify(vm.currentState)
				)
				this.axios
					.get('user/UpdCurrentState', {
						params: { stateId: item.id },
					})
					.then(function ({ data }) {
						if (!data.result) {
							vm.$notify.error({
								title: '错误',
								message: data.message,
							})
						}
					})
			}
		},
		uploadPassword() {
			this.show = false
			this.$router
				.push({ path: '/customs/setting', query: { key: 'updPass' } })
				.catch((err) => {
					console.log(err)
				})
		},
		updateDuration() {
			//保存每个状态在线时长
			let vm = this
			let date = new DateTime()
			let beforeTime = vm.currentState.currentTime
			let time = Date.now()
			let ti = date.getSecond(beforeTime, time)
			if (ti > 60) {
				this.axios
					.post('UserStatusRecord', {
						UserStateId: vm.currentState.id,
						Second: ti,
					})
					.then(function ({ data }) {})
			}
		},
		updUserHeadimg(url) {
			this.UserInfo.headimg = url
			let loginModel = JSON.parse(localStorage.getItem(this.LoginInfo))
			loginModel.headimg = url
			localStorage.setItem(this.LoginInfo, JSON.stringify(loginModel))
		},
		conversationCount(count) {
			localStorage.setItem('conversationDataCount', count)
			this.conversationDataCount = count
		},
	},
}
</script>
<style scoped>
/* .setting {
	font-size: 26px;
	cursor: pointer;
} */
.message {
	padding: 0px 0 30px 30px;
	box-sizing: border-box;
}

.access {
	margin-top: 20px;
}

.option {
	display: -webkit-flex;
	/*在webkit内核的浏览器上使用要加前缀*/
	display: flex;
	justify-content: flex-start;
	align-items: center;
}

.lablelist span {
	display: inline-block;
	margin: 15px 15px 5px 0;
	color: #666;
	min-width: 60px;
}

.lablelist span.special {
	vertical-align: top;
}

.iconfont {
	cursor: pointer;
}

.access textarea {
	resize: none;
	width: 100%;
	height: 50px;
	padding: 5px;
	line-height: 20px;
	outline: none;
}

.remark {
	resize: none;
	margin-top: 10px;
}

.save {
	float: right;
	margin: 10px 20px;
}

.f-right {
	float: right;
	cursor: pointer;
}
/*用户信息*/
.message {
	padding: 0px 0 30px 30px;
	box-sizing: border-box;
}

.access {
	margin-top: 20px;
}

.option {
	display: -webkit-flex;
	/*在webkit内核的浏览器上使用要加前缀*/
	display: flex;
	justify-content: flex-start;
	align-items: center;
}

.lablelist span {
	display: inline-block;
	margin: 15px 15px 5px 0;
	color: #666;
	min-width: 60px;
}

.lablelist span.special {
	vertical-align: top;
}

.iconfont {
	cursor: pointer;
}

.access textarea {
	resize: none;
	width: 100%;
	height: 50px;
	padding: 5px;
	line-height: 20px;
	outline: none;
}

.remark {
	resize: none;
	margin-top: 10px;
}

.save {
	float: right;
	margin: 10px 20px;
}

.f-right {
	float: right;
	cursor: pointer;
}

/*快捷回复*/
.tablist {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-pack: justify;
	-ms-flex-pack: justify;
	justify-content: center;
	-webkit-box-align: center;
	-ms-flex-align: center;
	align-items: center;
	line-height: 42px;
	border-bottom: 1px solid #ddd;
	padding: 0 15px;
}

.tablist > div {
	width: 40%;
	text-align: center;
	border-bottom: 2px solid transparent;
}

.tablist > div.on {
	width: 40%;
	text-align: center;
	color: #409eff;
	border-bottom: 2px solid #409eff;
}

.reply .el-input-group {
	padding: 0 5%;
	width: 90%;
	margin: 10px auto;
}

.words {
	padding: 5px 20px;
	line-height: 20px;
	color: #666;
}

.contains {
	width: 100%;
	flex: 1;
	display: flex;
	flex-direction: column;
	height: 100%;
}

header {
	width: 100%;
	height: 60px;
	line-height: 60px;
	border-bottom: 1px solid #e1e3e6;
}

.tabs {
	list-style: none;
	height: 60px;
	line-height: 60px;
	padding-left: 30px;
	float: left;
}

.tabs a {
	float: left;
	width: 108px;
	height: 38px;
	line-height: 38px;
	text-align: center;
	margin-left: 15px;

	border-radius: 3px;
	margin-top: 11px;
	border: 1px solid #ddd;
	cursor: pointer;
}

.tabs a.on {
	background-color: #409eff;
	color: #fff;
	border: 1px solid #409eff;
}

.group {
	float: right;
}

.search {
	float: right;
	margin-right: 21px;
}

.date {
	float: right;
	margin-right: 60px;
}

.select {
	background-color: transparent !important;
	min-width: 100px;
}

.date {
	width: 140px;
}

.search_box {
	float: left;
}

.dropmenu {
	float: left;
}

.dropmenu button {
	border-radius: 4px 0 0 4px !important;
	border-right: none;
}

/*菜单*/
.g-header {
	display: inline-block;
	float: right;
}

.g-header > div {
	display: inline-block;
}

.manage {
	margin-right: 50px;
	position: relative;
}

.work {
	position: relative;
	z-index: 50;
}

.dropdown-menu {
	width: 130px;
	position: absolute;
	padding: 6px 0px;
	background-color: #fff;
	box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
	-webkit-box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
	-moz-box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
	-o-box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
	border: 1px solid rgba(0, 0, 0, 0.15);
	list-style: none;
	top: 62px;
	left: 50%;
	margin-left: -72px;
	border-radius: 3px;
	z-index: 99;
}

.work .dropdown-menu {
	width: 100px;
	left: 50%;
	margin-left: -52px;
}

.dropdown-menu:before {
	position: absolute;
	right: 65px;
	top: -5px;
	content: '';
	z-index: 1;
	width: 0;
	height: 0;
	border-left: 10px solid transparent;
	border-right: 10px solid transparent;
	border-bottom: 6px solid #fff;
}

.work .dropdown-menu:before {
	position: absolute;
	right: 41px;
	top: -5px;
	content: '';
	z-index: 1;
	width: 0;
	height: 0;
	border-left: 10px solid transparent;
	border-right: 10px solid transparent;
	border-bottom: 6px solid #fff;
}

.dropdown-menu li {
	text-align: center;
	line-height: 40px;
}

.dropdown-menu li:hover {
	line-height: 40px;
	background-color: #409eff;
	color: white;
}

.fadeInDown {
	-webkit-animation-name: fadeInDown;
	animation-name: fadeInDown;
}

.animated {
	-webkit-animation-duration: 1s;
	animation-duration: 1s;
	-webkit-animation-fill-mode: both;
	animation-fill-mode: both;
}

@keyframes fadeInDown {
	0% {
		opacity: 0;
		-webkit-transform: translateY(-20px);
		-ms-transform: translateY(-20px);
		transform: translateY(-20px);
	}

	100% {
		opacity: 1;
		-webkit-transform: translateY(0);
		-ms-transform: translateY(0);
		transform: translateY(0);
	}
}

.icon-1 {
	display: inline-block;
	width: 14px;
	height: 14px;
	overflow: hidden;
	background-image: url(../../../assets/icons.png);
	background-size: 25px auto;
	background-position: 0 -270px;
	vertical-align: middle;
	margin-right: 4px;
}

.icon-2 {
	display: inline-block;
	width: 14px;
	height: 14px;
	background-image: url(../../../assets/icons.png);
	background-size: 25px auto;
	background-position: 0 -240px;
	vertical-align: middle;
	margin-right: 4px;
}

/*main*/
.main {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	position: relative;
	height: 100%;
	overflow-x: hidden;
}

.aside {
	width: 18%;
	height: 100%;
	border-right: 1px solid #ddd;
}

.answer {
	width: 48%;
	height: 100%;
	border-right: 1px solid #ddd;
	transition: 0.2s width;
}

.answer.on {
	width: 64%;
}

.reply {
	width: 16%;
	height: 100%;
	border-right: 1px solid #ddd;
	overflow: hidden;
}

.reply.on {
	width: 0%;
}

.userinfor {
	width: 18%;
	height: 100%;
}

.flex {
	height: 100%;
	overflow: auto;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-orient: vertical;
	-webkit-box-direction: normal;
	-ms-flex-direction: column;
	flex-direction: column;
	position: relative;
	width: 100%;
	-webkit-box-sizing: border-box;
	box-sizing: border-box;
}

.points {
	height: 36px;
	line-height: 35px;
	padding-left: 30px;
	font-size: 14px;
	color: #fe1c11;
}

.connect {
	display: inline-block;
	height: 25px;
	line-height: 25px;
	padding: 0px 15px;
	text-align: center;
	border-radius: 5px;
	color: #fff;
	background-color: #409eff;
	float: right;
	margin: 4px;
}

.Transfer {
	display: inline-block;
	height: 25px;
	line-height: 25px;
	padding: 0px 15px;
	text-align: center;
	border-radius: 5px;
	color: #fff;
	background-color: #409eff;
	margin: 4px;
}

.ended {
	display: inline-block;
	height: 25px;
	line-height: 25px;
	padding: 0px 15px;
	text-align: center;
	border-radius: 5px;
	color: #fff;
	background-color: #f74b55;
	margin: 4px 0px 4px 4px;
}

.title {
	height: 42px;
	line-height: 42px;
	background-color: #f2f3f5;
	font-size: 14px;
	display: -webkit-flex;
	/*在webkit内核的浏览器上使用要加前缀*/
	display: flex;
	justify-content: flex-start;
	align-items: center;
	padding-left: 20px;
}

.aside title {
	padding-left: 30px;
	border-bottom: 1px solid #ddd;
}

.reply .title {
	padding: 0 10px;
}

.transition-box {
	padding: 10px 15px;
	border-bottom: 1px solid #eee;
}

.tips {
	float: right;
	border-radius: 15px;
	padding: 0 15px;
	cursor: pointer;
}

.tips.green {
	color: #fff;
	background-color: #047d0c;
}

.tips.red {
	color: #fff;
	background-color: #f74b55;
}

.tips.blue {
	color: #3781ff;
	padding: 0;
}

.user {
	line-height: 25px;
}

.from {
	margin-top: 10px;
}

.create_time {
	float: right;
}

.el-icon-caret-right {
	font-size: 20px;
	margin-right: 5px;
}

.el-icon-caret-bottom {
	font-size: 20px;
	margin-right: 5px;
}

/*answer会话*/
.flex-title {
	display: -webkit-flex;
	/*在webkit内核的浏览器上使用要加前缀*/
	display: flex;
	justify-content: space-between;
	align-items: center;
	height: 42px;
	line-height: 42px;
	border-bottom: 1px solid #ddd;
	padding: 0 15px;
}

.nickname {
	color: #bbb;
}

.flex-time span {
	color: #fe1c11;
}

.talk {
	padding: 10px 35px;
	height: 60%;
	border-bottom: 1px solid #ddd;
	overflow-y: auto;
	overflow-x: hidden;
}

.search-box {
	line-height: 44px;
	border-bottom: 1px solid #ddd;
}

.search-box .el-input-group {
	width: 320px;
	margin-left: 20px;
}

.talk p {
	text-align: center;
	color: #bbb;
	line-height: 30px;
}

.container {
	overflow-x: hidden;
	overflow-y: auto;
}

/*滚动条样式*/
::-webkit-scrollbar {
	width: 14px;
}

::-webkit-scrollbar-track {
	border-radius: 5px;
}

::-webkit-scrollbar-thumb {
	background-color: #d6d6d6;
	border-radius: 5px;
}

.talk_left {
	display: -webkit-flex;
	/*在webkit内核的浏览器上使用要加前缀*/
	display: flex;
	justify-content: flex-start;
	align-items: flex-start;
	margin-bottom: 10px;
	min-width: 100px;
}

.talk_left .content {
	margin-left: 10px;
}

.talk_left .content img {
	max-width: 300px;
}

.text {
	max-width: 400px;
	padding: 15px;
	background-color: #dcedf9;
	border-radius: 5px;
	font-size: 14px;
	letter-spacing: 1px;
}

.talk_left .text::after {
	position: absolute;
}

.talk_right {
	display: -webkit-flex;
	/*在webkit内核的浏览器上使用要加前缀*/
	display: flex;
	justify-content: flex-end;
	align-items: flex-start;
	margin-bottom: 10px;
}

.talk_right .content {
	margin-right: 10px;
}

.talk_right .content img {
	max-width: 225px;
}

.heading {
	width: 40px;
	height: 40px;
	border-radius: 50%;
}

.heading img {
	width: 100%;
	height: 100%;
	border-radius: 50%;
}

.tool {
	height: 40px;
	line-height: 40px;
	padding: 0;
	background-color: #fafafa;
	display: -webkit-flex;
	/*在webkit内核的浏览器上使用要加前缀*/
	display: flex;
	justify-content: flex-start;
	align-items: center;
}

.tool i {
	font-size: 25px;
	margin-left: 20px;
	cursor: pointer;
	vertical-align: middle;
}

.charInput {
	padding: 5px 15px;
	min-height: 120px;
	max-height: 120px;
	outline: none;
	font-size: 20px;
	line-height: 30px;
	word-wrap: break-word;
}

/*表情*/

.send {
	display: inline-block;
	height: 35px;
	line-height: 35px;
	padding: 0px 15px;
	text-align: center;
	border-radius: 5px;
	color: #fff;
	background-color: #409eff;
	float: right;
	margin: 4px;
	outline: none;
	border: none;
	cursor: pointer;
	margin-right: 20px;
}

.emoji_box {
	position: relative;
}

.emoji {
	position: absolute;
	background: #fff;
	width: 425px;
	height: 180px;
	border: 1px solid #ebeef5;
	padding: 12px;
	z-index: 2000;
	color: #606266;
	line-height: 1.4;
	text-align: justify;
	font-size: 14px;
	-webkit-box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
	box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
	word-break: break-all;
	bottom: 45px;
}

.emoji span {
	display: inline-block;
	width: 30px;
	height: 30px;
	cursor: pointer;
	-webkit-user-select: none;
	-moz-user-select: none;
	-ms-user-select: none;
	user-select: none;
	font-style: normal;
	font-size: 20px;
}

.page {
	display: flex;
	bottom: 0;
	left: 0;
	width: 100%;
	padding-top: 5px;
	margin-top: 10px;
	border-top: 1px solid #e6e6e6;
}

.el-tabs__content {
	height: 130px;
}

.page > div {
	-webkit-box-flex: 1;
	flex: 1;
}

#file {
	display: none;
}

.close {
	font-size: 24px;
	cursor: pointer;
	color: #888;
}

/*.chatframe-icon{
  }
  .chatframe-icon span{
    display: inline-block;
  }
  #charInput img{
    display:inline-block;
    width: 20px;
    height: 20px;
  }
  .text_emoji img {
    display:inline-block;
    width: 20px;
    height: 20px;
    vertical-align: bottom;
  }*/
.chatframe-text img {
	display: inline-block;
	width: 20px;
	height: 20px;
	vertical-align: bottom;
}

.search_box .el-input__inner {
	border-radius: 0 4px 4px 0;
	padding-left: 30px;
	background: url(../../../assets/search.png) no-repeat 6px center;
	background-size: 8%;
}

.date .el-input__inner {
	border-radius: 4px;
}
</style>


// WEBPACK FOOTER //
// src/components/customer/customers/customer.vue